// extracted by mini-css-extract-plugin
export default {"mainContainer":"Layout_mainContainer__UDMLE","layout":"Layout_layout__bMgkl"};